export default __webpack_public_path__ + "static/media/stepper-valid.f70b6554.svg";